import { Directive } from '@angular/core';
import { ShowHideDirective } from '@angular/flex-layout';

const selector = `[fxShow.tablet.portrait]`;
const inputs = ['fxShow.tablet.portrait'];

@Directive({
  selector, 
  inputs
})
export class CustomFxShowTabletPortraitDirective extends ShowHideDirective {
  protected inputs = inputs;
}
